import React from "react";

//UI Material
import { Box, CircularProgress, circularProgressClasses } from "@mui/material";

//Helpers
import {
  typographyForCustomizedFontSize,
} from "../../Helpers/typography";

export default function CircularPercentage({ value }) {
  return (
    <Box
      sx={{
        position: "relative",
        alignItems: "center",
        display: "flex",
      }}
    >
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
        size={40}
        thickness={3}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        sx={{
          color: "#38bfc3",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={40}
        thickness={3}
        value={value}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {typographyForCustomizedFontSize(`${value}%`, "10px")}
      </Box>
    </Box>
  );
}
